import Card_right from "../components/CardRight";
export default function PraktiskInformasjon() {
  return (
      <Card_right >
          <div className="card-left-title">
            Praktisk Informasjon
          </div>
          <div className="card-left-content">
          <p>
            Gjerne ta med en jakke eller en lett genser i tilfelle det blir kjølig i løpet av kvelden. Siden det er helt nede ved vannet kan det blåse litt, og lokalet har samme temperatur inne som ute. <br /><br/>

            Vi har også fått beskjed om at dere ikke skal parkere for nære båtene på parkeringsplassen. Det er mulig at porten inn til parkeringa er stengt, og da vil dere etterhvert få en kode dere kan bruke for å åpne porten. <br /><br/>
          </p>
        </div>
      </Card_right>
  );
}